import { defineMessages } from '../define';

/** Verbs, table furniture and failure copy shared by every screen. */
export const common = defineMessages({
  en: {
    'action.save': 'Save',
    'action.saveChanges': 'Save changes',
    'action.cancel': 'Cancel',
    'action.confirm': 'Confirm',
    'action.create': 'Create',
    'action.delete': 'Delete',
    'action.edit': 'Edit',
    'action.close': 'Close',
    'action.copy': 'Copy',
    'action.copied': 'Copied',
    'action.retry': 'Try again',
    'action.refresh': 'Refresh',
    'action.clearFilters': 'Clear filters',
    'action.back': 'Back',
    'action.search': 'Search',
    'action.export': 'Export',
    'action.test': 'Test',
    'action.enable': 'Enable',
    'action.disable': 'Disable',

    'state.loading': 'Loading…',
    'state.saving': 'Saving…',
    'state.none': 'None',
    'state.never': 'Never',
    'state.unknown': 'Unknown',
    'state.enabled': 'Enabled',
    'state.disabled': 'Disabled',
    'state.active': 'Active',
    'state.inactive': 'Inactive',
    'state.yes': 'Yes',
    'state.no': 'No',
    'state.all': 'All',
    'state.any': 'Any',

    'page.previous': 'Previous',
    'page.next': 'Next',
    'page.previousLabel': 'Previous page',
    'page.nextLabel': 'Next page',
    'page.empty': 'No {label}',
    'page.range': '{first}–{last} of {total} {label}',

    'unit.items': 'items',
    'unit.sessions': 'sessions',
    'unit.chats': 'chats',
    'unit.messages': 'messages',
    'unit.contacts': 'contacts',
    'unit.users': 'users',
    'unit.keys': 'keys',
    'unit.entries': 'entries',
    'unit.deliveries': 'deliveries',
    'unit.hits': 'hits',
    'unit.lines': 'lines',
    'unit.keywords': 'keywords',
    'unit.webhooks': 'webhooks',

    'error.forbidden.title': 'You do not have access to this',
    'error.forbidden.detail': 'Ask an administrator to raise your role if you need it.',
    'error.notFound.title': 'Not found',
    'error.notFound.detail': 'It may have been deleted since this page loaded.',
    'error.server.title': 'The server could not complete the request',
    'error.offline.title': 'Cannot reach the gateway',
    'error.offline.detail':
      'The API is not responding. Check that the backend container is running.',
    'error.generic.title': 'Something went wrong',
    'error.reference': 'Reference {reference} — quote this when reporting the problem',

    'confirm.typePrompt': 'Type {value} to confirm.',
    'confirm.typeLabel': 'Confirmation text',

    'toolbar.searchDefault': 'Search…',
    'toolbar.clearSearch': 'Clear search',
    'breadcrumb.label': 'Breadcrumb',
    'sheet.panel': 'Panel',

    'session.all': 'All sessions',
    'session.select': 'Select a session',
  },
  th: {
    'action.save': 'บันทึก',
    'action.saveChanges': 'บันทึกการเปลี่ยนแปลง',
    'action.cancel': 'ยกเลิก',
    'action.confirm': 'ยืนยัน',
    'action.create': 'สร้าง',
    'action.delete': 'ลบ',
    'action.edit': 'แก้ไข',
    'action.close': 'ปิด',
    'action.copy': 'คัดลอก',
    'action.copied': 'คัดลอกแล้ว',
    'action.retry': 'ลองอีกครั้ง',
    'action.refresh': 'รีเฟรช',
    'action.clearFilters': 'ล้างตัวกรอง',
    'action.back': 'ย้อนกลับ',
    'action.search': 'ค้นหา',
    'action.export': 'ส่งออก',
    'action.test': 'ทดสอบ',
    'action.enable': 'เปิดใช้งาน',
    'action.disable': 'ปิดใช้งาน',

    'state.loading': 'กำลังโหลด…',
    'state.saving': 'กำลังบันทึก…',
    'state.none': 'ไม่มี',
    'state.never': 'ไม่เคย',
    'state.unknown': 'ไม่ทราบ',
    'state.enabled': 'เปิดใช้งาน',
    'state.disabled': 'ปิดใช้งาน',
    'state.active': 'ใช้งานอยู่',
    'state.inactive': 'ไม่ได้ใช้งาน',
    'state.yes': 'ใช่',
    'state.no': 'ไม่',
    'state.all': 'ทั้งหมด',
    'state.any': 'ทุกประเภท',

    'page.previous': 'ก่อนหน้า',
    'page.next': 'ถัดไป',
    'page.previousLabel': 'หน้าก่อนหน้า',
    'page.nextLabel': 'หน้าถัดไป',
    'page.empty': 'ไม่มี{label}',
    'page.range': '{first}–{last} จาก {total} {label}',

    'unit.items': 'รายการ',
    'unit.sessions': 'เซสชัน',
    'unit.chats': 'แชท',
    'unit.messages': 'ข้อความ',
    'unit.contacts': 'รายชื่อ',
    'unit.users': 'ผู้ใช้',
    'unit.keys': 'คีย์',
    'unit.entries': 'รายการ',
    'unit.deliveries': 'การส่ง',
    'unit.hits': 'ผลการจับคู่',
    'unit.lines': 'บรรทัด',
    'unit.keywords': 'คำสำคัญ',
    'unit.webhooks': 'webhook',

    'error.forbidden.title': 'คุณไม่มีสิทธิ์เข้าถึงส่วนนี้',
    'error.forbidden.detail': 'หากจำเป็นต้องใช้ กรุณาขอให้ผู้ดูแลระบบเพิ่มสิทธิ์ให้',
    'error.notFound.title': 'ไม่พบข้อมูล',
    'error.notFound.detail': 'ข้อมูลอาจถูกลบไปแล้วหลังจากเปิดหน้านี้',
    'error.server.title': 'เซิร์ฟเวอร์ไม่สามารถดำเนินการตามคำขอได้',
    'error.offline.title': 'เชื่อมต่อเกตเวย์ไม่ได้',
    'error.offline.detail': 'API ไม่ตอบสนอง กรุณาตรวจสอบว่าคอนเทนเนอร์ backend ทำงานอยู่',
    'error.generic.title': 'เกิดข้อผิดพลาดบางอย่าง',
    'error.reference': 'รหัสอ้างอิง {reference} — กรุณาแจ้งรหัสนี้เมื่อรายงานปัญหา',

    'confirm.typePrompt': 'พิมพ์ {value} เพื่อยืนยัน',
    'confirm.typeLabel': 'ข้อความยืนยัน',

    'toolbar.searchDefault': 'ค้นหา…',
    'toolbar.clearSearch': 'ล้างคำค้นหา',
    'breadcrumb.label': 'เส้นทางนำทาง',
    'sheet.panel': 'แผงข้อมูล',

    'session.all': 'ทุกเซสชัน',
    'session.select': 'เลือกเซสชัน',
  },
});
